import { LANGUAGES, translations } from "../contexts/LanguageContext";

const STORAGE_KEY = 'preferred-language';
const getStoredLanguage = async () => {
  if (typeof window === 'undefined') return null;
  
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to read language preference from localStorage:', error);
    return null;
  }
};

/**
 * Get the current language translation docs
 * @returns fileTranslation (object)
 */
const getLanguage = async () => {
    const language = await getStoredLanguage();

    const value = translations[language];
    return value
}

export default getLanguage